<mat-icon
  class="rp-icon"
  [class]="size()"
  [style.color]="color()"
  [style.opacity]="disabled() ? '.5' : 1"
  [svgIcon]="iconName()"
  (click)="onIconClick($event)"
/>
